export default __webpack_public_path__ + "static/media/Account_profile_upload_image.29d4b404.svg";